import * as React from "react";
import {rgba} from "polished";

import "./sub-header.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const SubHeader = ({sub}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div className="sub-header sub-header-42e">
            {sub?.headerTitle && (
                <h2
                    className="title"
                    style={{color: themeScheme.coloredText}}
                >{sub.headerTitle}</h2>
            )}
            {sub?.displayContent &&(
                <a className="image" href={sub?.hyperlink && sub.hyperlink}>
                    <img className="image" src={sub.displayContent}/>
                </a>
            )}
            {sub?.displayText && (
                <div
                    className="text"
                    style={{background: rgba(themeScheme.xpresso.menuBackgroundColor, .03)}}
                >
                    <div className="left-bar" style={{background: themeScheme.xpresso.menuBackgroundColor}}/>
                    <div className="message" dangerouslySetInnerHTML={{__html: sub.displayText}}/>
                </div>
            )}
        </div>
    )
);
